<template>
    <a-card :bordered="false">
        <!-- Query area -->
        <div class="table-page-search-wrapper">
            <a-form layout="inline">
                <a-row :gutter="24">
                    <a-col :md="8" :sm="24">
                        <a-form-item :label="$t('date')">
                            <a-range-picker v-model="queryParam.dateRange" style="width: 100%"
                                :placeholder="[$t('Startdate'), 
                                $t('Enddate')]" 
                                @change="onDateChange"  
                                :format="dateFormat"
                                valueformat="YYYY-MM-DD"
                                />
                        </a-form-item>
                    </a-col>
                    <a-col :md="1" :sm="24">
                        <span class="table-page-search-submitButtons">
                            <a-button type="primary" @click="handleSearch">{{ $t('search') }}</a-button>
                        </span>
                    </a-col>
                </a-row>
            </a-form>
        </div>

        <!-- Table area -->
        <a-table bordered ref="table" size="default" rowKey="id" :columns="columns" :dataSource="dataSource"
            :pagination="pagination" :loading="loading" @change="handleTableChange">
            <span slot="money" slot-scope="text">
                {{ text | FenToDong }}
            </span>
        </a-table>
    </a-card>
</template>

<script>
import { getIncomeSummary } from '@/webpublicapi/vietnamBackstage'
import lang from '@/i18n/lang'
import moment from 'moment'

export default {
    name: 'IncomeSummary',
    components: {
    },
    data() {
        return {
          dateFormat: 'DD-MM-YYYY',
            lang,
            // Query params
            queryParam: {
                dateRange: [],
                startDate: '',
                endDate: ''
            },
            dataSource: [],
            loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`
            }
        }
    },
    computed: {
        columns() {
            return [
                { title: this.$t('date'), dataIndex: 'statDate', align: 'center', customRender: (text) => text ? moment(text).format('DD-MM-YYYY') : '' },
                { title: this.$t('investorList.ysze'), dataIndex: 'totalReceivable', align: 'center', scopedSlots: { customRender: 'money' } },
                { title: this.$t('investorList.ssze'), dataIndex: 'totalReceived', align: 'center', scopedSlots: { customRender: 'money' } },
                { title: this.$t('investorList.jkrys'), dataIndex: 'borrowerReceivable', align: 'center', scopedSlots: { customRender: 'money' } },
                { title: this.$t('investorList.jkrss'), dataIndex: 'borrowerReceived', align: 'center', scopedSlots: { customRender: 'money' } },
                { title: this.$t('investorList.tzrys'), dataIndex: 'investorReceivable', align: 'center', scopedSlots: { customRender: 'money' } },
                { title: this.$t('investorList.tzrss'), dataIndex: 'investorReceived', align: 'center', scopedSlots: { customRender: 'money' } },
            ]
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        onDateChange(dates) {
            if (dates && dates.length === 2) {
                this.queryParam.startDate = dates[0].format('YYYY-MM-DD')
                this.queryParam.endDate = dates[1].format('YYYY-MM-DD')
            } else {
                this.queryParam.startDate = ''
                this.queryParam.endDate = ''
            }
        },
        handleSearch() {
            this.pagination.current = 1
            this.loadData()
        },
        handleTableChange(pagination) {
            if (this.pagination.pageSize !== pagination.pageSize) {
                this.pagination.current = 1
            } else {
                this.pagination.current = pagination.current
            }
            this.pagination.pageSize = pagination.pageSize
            this.loadData()
        },
        loadData() {
            this.loading = true

            // If no start/end time selected, default query recent 30 days
            if (!this.queryParam.startDate && !this.queryParam.endDate) {
                const end = moment().endOf('day')
                const start = moment().startOf('day').subtract(30, 'days')
                this.queryParam.startDate = start.format('YYYY-MM-DD')
                this.queryParam.endDate = end.format('YYYY-MM-DD')
            }

            const params = {
                current: this.pagination.current,
                size: this.pagination.pageSize,
                startDate: this.queryParam.startDate,
                endDate: this.queryParam.endDate
            }

            getIncomeSummary(params)
                .then(res => {
                    if (res.success || res.respCode === 1000 || res.code === 200) {
                        const data = res.respData || {}
                        this.dataSource = data.records || []
                        this.pagination.total = data.total || 0
                    } else {
                        this.$message.warning(res.respMsg || res.message || this.$t('platformCollection.operation_failed'))
                    }
                })
                .catch(() => {
                    this.$message.error(this.$t('platformCollection.operation_failed'))
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';

.table-page-search-wrapper {
    margin-bottom: 16px;
}
</style>